// SpacerBlockEditor — vertical breathing room with preset heights.

import type { SpacerBlock, Block } from "../../../lib/blocks";
import { t } from "../theme";

export interface SpacerBlockEditorProps {
  block: SpacerBlock;
  onChange: (patch: Partial<Block>) => void;
  isSelected: boolean;
}

const HEIGHTS: SpacerBlock["height"][] = [16, 24, 32, 48, 64, 96, 128];

export function SpacerBlockEditor({
  block,
  onChange,
  isSelected,
}: SpacerBlockEditorProps) {
  return (
    <div>
      {isSelected && (
        <div style={{ display: "flex", gap: 6, marginBottom: 8, fontFamily: t.sans, flexWrap: "wrap" }}>
          {HEIGHTS.map((h) => (
            <button
              key={h}
              type="button"
              onClick={() => onChange({ height: h } as Partial<SpacerBlock>)}
              style={{
                padding: "3px 8px",
                fontSize: 11,
                borderRadius: 4,
                background: block.height === h ? t.accentSoft : "transparent",
                color: block.height === h ? t.accent : t.text3,
                border: `1px solid ${block.height === h ? t.accentStrong : t.border}`,
                cursor: "pointer",
              }}
            >
              {h}px
            </button>
          ))}
        </div>
      )}
      <div
        style={{
          height: block.height,
          border: `1px dashed ${isSelected ? t.accentStrong : t.border}`,
          borderRadius: 4,
          background: isSelected ? t.accentSoft : "transparent",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: t.text4,
          fontFamily: t.sans,
          fontSize: 11,
          transition: t.transition,
        }}
      >
        {block.height}px spacer
      </div>
    </div>
  );
}
